import React from "react";
import classes from "./SubLayout.module.css";

const SubLayout = ({ children }) => {
  return <div className={classes.sub_container_sub}>{children}</div>;
};

export default SubLayout;
